import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';

import Link from 'core/components/Link';
import Avatar from 'core/components/Avatar';
import Social from 'core/components/Social';
import AuthorTypeLabel from 'core/components/AuthorTypeLabel';

import modelPropTypes, { personAttributes } from 'core/utils/prop-types/model';
import themePropTypes from 'core/utils/prop-types/theme';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

import styles from './index.styl';

function AuthorCard(props) {
  const {
    author,
    theme,
    allAuthorsLink,
    allAuthorsLinkComponent: AllAuthorsLinkComponent,
  } = props;

  const {
    name,
    email,
    job_title: jobTitle,
    biography,
    avatar,
    social_networks: socialNetworks,
    type,
    is_archived: isArchived,
  } = author.attributes;

  const userAvatar = avatar?.attributes?.versions?.original;

  const authorPageAtoms = theme.controls.authorPage;

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .${styles.emailJobTitle}
          color ${theme.colors.primary}
        .${styles.archivedAuthor}
          font ${authorPageAtoms.card.archivedAuthor.font}
        .${styles.name}
          font ${authorPageAtoms.card.name.font}
      `}</style>
    </scope>
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.innerWrapper}>
        <Avatar
          src={userAvatar}
          size={120}
        />
        <div className={styles.authorInfo}>
          <div className={styles.name}>
            <h1 className={scope.wrapClassNames(styles.name)} data-qa='author-name'>{name}</h1>
            <div className={styles.label} data-qa='author-type'>
              <AuthorTypeLabel type={type} />
            </div>
          </div>
          {isArchived && <p className={scope.wrapClassNames(styles.archivedAuthor)}>архивный автор</p>}
          {!!email && (
            <p className={scope.wrapClassNames(styles.emailJobTitle)}>
              <Link
                className={scope.wrapClassNames('emailLink')}
                to={`mailto:${email}`}
                dataQa='author-email'
                type={authorPageAtoms.emailLinkType}
              >
                {email}
              </Link>
            </p>
          )}
          {!!jobTitle && (
            <p className={scope.wrapClassNames(styles.emailJobTitle)} data-qa='author-job-title'>
              {jobTitle}
            </p>
          )}
          {biography && <p className={styles.bio} data-qa='author-bio'>{biography}</p>}
          <Social socials={socialNetworks} />
        </div>
      </div>
      {allAuthorsLink && (
        <Link
          to={allAuthorsLink}
          className={scope.wrapClassNames(styles.allAuthorsLink)}
          dataQa='all-authors'
        >
          <AllAuthorsLinkComponent>Все авторы</AllAuthorsLinkComponent>
        </Link>
      )}
      <scope.styles />
    </div>
  );
}

AuthorCard.defaultProps = {
  allAuthorsLinkComponent: 'span',
};

AuthorCard.propTypes = {
  author: modelPropTypes(personAttributes).isRequired,
  /** @ignore */
  theme: themePropTypes(`{
    colors: {
      placeholder,
      primary,
    },
    controls: {
      authorPage: {
        card: {
          archivedAuthor: {
            font,
          },
          name: {
            font,
          },
        },
      }
    }
  `),
  /**
   * Ссылка на страницу "Все авторы"
   */
  allAuthorsLink: PropTypes.string,
  /**
   * Компонент или тег для содержимого ссылки на страницу "Все авторы"
   */
  allAuthorsLinkComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

const AuthorCardWithHOCs = withTheme(AuthorCard);
AuthorCardWithHOCs.displayName = 'AuthorCard';

export { AuthorCard as StorybookComponent };
export default AuthorCardWithHOCs;
